import { Edit, Delete } from "@mui/icons-material";

import { TableActions } from "../../components/v3";

/**
 * Route paths for the expense module.
 * Single source of truth — reuse these instead of hard-coding `/expense...` strings.
 */
export const EXPENSE_ROUTES = {
  root: "/expense",
  details: "/expense/:id",
  add: "/expense/add",
  edit: "/expense/edit/:expenseId",
  worker: "/expense/worker/:workId",
  vendor: "/expense/vendor/:invoiceId",
  subcontractor: "/expense/subcontractor/:paymentId",
} as const;

export const getExpenseTableColumns = (handleActions, hasEditExpense, hasDeleteExpense, isProjectPage) => {
  const headers = [
    { field: "sl", headerName: "sl no", flex: 0.2, sortable: false },
    { field: "date", headerName: "date", flex: 0.4, sortable: true, sortingOrder: ["desc", "asc", null] },
    { field: "projectName", headerName: "project name", flex: 1, sortable: false },
    { field: "description", headerName: "description", flex: 1, sortable: false },
    { field: "type", headerName: "type", flex: 1, sortable: false },
    { field: "amount", headerName: "amount", flex: 0.5, sortable: true },
  ];

  if (hasEditExpense || hasDeleteExpense) {
    headers.push({
      field: "actions",
      headerName: "Action",
      sortable: false,
      flex: 0.5,
      renderCell: (params) => {
        const actions = [];

        if (hasEditExpense) {
          actions.push({
            icon: Edit,
            type: "edit",
            label: "Edit",
            onClick: handleActions,
          });
        }

        if (hasDeleteExpense) {
          actions.push({
            icon: Delete,
            type: "delete",
            label: "Delete",
            onClick: handleActions,
          });
        }
        return <TableActions item={params} actions={actions} />;
      },
    });
  }

  return isProjectPage ? headers.filter((col) => col.field !== "projectName") : headers;
};
